import React from "react";
import EvacuadosPorProvinciaTmp from '../../../containers/EvacuadosPorProvincia';
import { CAMPAIGN_2024 } from '../../../constants';

const EvacuadosPorProvincia = () => {

  return <EvacuadosPorProvinciaTmp campaign={CAMPAIGN_2024} year={2024}/>;
};

export default EvacuadosPorProvincia;
